import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StoreReportCustomFieldsMapped, Store } from '../../models/job-report';
import { UserContact } from '../../../../models/user-contact';
import { UserContactService } from '../../../services/data/user-contact/user-contact.service';
import { ContactPickerService } from '../../../contact-picker/contact-picker.service';

import * as _ from 'lodash';
import { UserGroupService } from '../../../services/data/user-group/user-group.service';
import { UserGroup } from '../../../../models/user-group';

export class FieldContactDetail {
  is_visible: boolean;
  is_notify: boolean;
}

@Component({
  selector: 'tn-field-contact',
  templateUrl: './field-contact.component.html',
  styleUrls: ['./field-contact.component.scss']
})
export class FieldContactComponent implements OnInit {

  @Input() field: StoreReportCustomFieldsMapped;
  @Input() store: Store;
  @Input() isInput: boolean = false;

  @Output() onFieldUpdate: EventEmitter<StoreReportCustomFieldsMapped> = new EventEmitter<StoreReportCustomFieldsMapped>(null);

  contacts: UserContact[] = [];
  contactName: string = "";

  storeGroupMembers: UserContact[] = [];
  isGottenMissingContact: boolean = false;

  constructor(
    private _userContactService: UserContactService,
    private _contactPickerService: ContactPickerService,
    private _userGroupService: UserGroupService
  ) { }

  ngOnInit() {
    
  }

  ngOnChanges() {
    this.parseAnswerContact();
  }

  parseAnswerContact(): void {
    if (this.field.answer.value) {
      let missingContacts = [];
      this.contacts = [];
      _.each(JSON.parse(this.field.answer.value), (userId: string) => {
        let contact = this._userContactService.getUserContactByUserId(userId);
        if (_.isEmpty(contact)) {
          missingContacts.push(userId);
        } else {
          this.contacts.push(contact);
        }
      });
      if (!this.isGottenMissingContact && missingContacts.length > 0) {
        this._userContactService.getContactRequest(
          missingContacts,
          () => {
            this.isGottenMissingContact = true;
            this.parseAnswerContact();
          }
        );
      }
      this.sortContactByName();
    }
  }

  getStoreGroupMember(callback: Function): void {
    let userGroup = this._userGroupService.getUserGroupByUserGroupId(this.store.store_id);
    if (userGroup) {
      this.parseMemberContactFromUserGroup(userGroup, callback);
    } else {
      this._userGroupService.getUserGroupContactRequest(
        [this.store.store_id],
        () => {
          this.getStoreGroupMember(callback);
        }
      );
    }
  }

  parseMemberContactFromUserGroup(userGroup: UserGroup, callback: Function): void {
    this.storeGroupMembers = _.map(userGroup.members, (userId) => {
      return this._userContactService.getUserContactByUserId(userId);
    });
    callback();
  }

  sortContactByName(): void {
    this.contacts = _.orderBy(this.contacts, [(c: UserContact) => {
      return c.name.toLowerCase();
    }]);
  }

  openContactPicker() {
    this.getStoreGroupMember(
      () => {
        this._contactPickerService.openContactPicker(
          this.field.definition.name,
          false,
          false,
          false,
          (contacts) => {
            this.contacts = contacts;
            this.sortContactByName();
            this.onChange();
          },
          true,
          null,
          this.storeGroupMembers
        );
      }
    );
  }

  getAnswerValue(): string {
    return JSON.stringify(_.map(this.contacts, 'user_id'));
  }

  onChange() {
    this.field.answer.value = this.getAnswerValue();
    this.onFieldUpdate.emit(this.field);
  }

}
